<template>
	<div>		
		<form action="" method="POST" @submit="ajaxSend" id="form">
			<div class="row">
				<div class="col-12 col-lg-6">
					<div class="form-group">
						<input type="text" name="name" id="name" class="form-control" placeholder="Imię i nazwisko" required/>
						<label>Imię i nazwisko</label>
					</div>
					<div class="form-group">
						<input type="tel" name="phone" id="phone" class="form-control" placeholder="Numer telefonu" />
						<label>Numer telefonu</label>
					</div>
					<div class="form-group">
						<input type="email" name="email" id="email" class="form-control" placeholder="Adres e-mail" required/>
						<label>Adres e-mail</label>
					</div>
				</div>
				<div class="col-12 col-lg-6 d-flex align-items-stretch">
					<div class="form-group">
						<textarea name="question" id="question" class="form-control h-100" placeholder="Treść wiadomości"></textarea>
						<label>Treść wiadomości</label>
					</div>
				</div>
			</div>
			<div class="row mt-4 mt-lg-0">
				<div class="col-12">
					<div class="form-group form-group--checkbox d-flex mb-0">
						<label for="checkbox" class="label-checkbox pt-1">
							<span>
								<input type="checkbox" id="checkbox" name="RODO" required>
								<i></i>
							</span>
						</label>
						<div class="d-flex flex-column checkbox-text">
							<p>
								Wyrażam zgodę na przetwarzanie moich danych osobowych przez firmę ANGO Andrzej Markowski z siedzibą w Warszawie ul. Potockich 22A w celu skontaktowania się i przedstawienia oferty.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12 text-center pt-3">
					<button class="btn btn-gradient" type="submit">
						Wyślij wiadomość
					</button>
				</div>
			</div>
		</form>
		<div id="thankYou" class="d-none">
			<span class="text-center">Dziękujemy wiadomość została wysłana</span>
		</div>
	</div>
</template>

<script>
	export default{
		methods: {
			ajaxSend(e){
				e.preventDefault();
				this.$gtag.event('Wysłany', {
					'event_category': 'Formularz',
					'event_label': 'Formularz kontaktowy',
					'non_interaction': false
				})
				const xhr = new XMLHttpRequest();
				const form = document.getElementById('form');
				xhr.open("POST", 'https://submit-form.com/8MSOa0GzZFkSd3lppnwTJ');
				xhr.setRequestHeader("Content-Type", "application/json");

				xhr.onreadystatechange = function() {
                    if (xhr.readyState == 4){
						form.classList.add('d-none');
						const thankYou = document.getElementById('thankYou');
						thankYou.classList.remove('d-none');
						thankYou.classList.add('d-block');
					}
				};
				xhr.send(
					JSON.stringify({
						"Imię i nazwisko": form.querySelector('[name="name"]').value,
						"Numer telefonu": form.querySelector('[name="phone"]').value,
						"Adres e-mail": form.querySelector('[name="email"]').value,
						"Treść wiadomości": form.querySelector('[name="question"]').value,
						"Zgoda RODO": form.querySelector('[name="RODO"]').checked ? 'tak' : 'nie'
					})					
				);
			}
		}
	}
</script>